import { createSlice } from '@reduxjs/toolkit';
import { setToStore } from '../pages/Utils/fn';
import constants from '../pages/Utils/constants.json';

export const favoritesSlice = createSlice({
	name: 'favorites',
	initialState: {
		data: [],
	},
	reducers: {
		setFavorites: function (state, action) {
			state.data = action.payload;
		},

		addFavorite: function (state, action) {
			let arr = state.data.filter(item => item.item_code === action.payload.item_code);
			if (arr.length === 0) {
				if (state.data.length >= 30) state.data.pop();
				state.data.unshift(action.payload);
				setToStore(constants.FAVORITES, state.data);
			}
		},

		removeFavorite: function (state, action) {
			state.data = state.data.filter(item => item.item_code !== action.payload);
			setToStore(constants.FAVORITES, state.data);
		},
	},
});

export const { setFavorites, addFavorite, removeFavorite } = favoritesSlice.actions;
export default favoritesSlice.reducer;
